/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpErrorResponse,
	HttpHeaders,
} from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { IpbLocalStorageService } from '@ipb-genesis/ipb-services';
import { Router } from '@angular/router';
import { AuthService } from '../core/services/auth/auth.service';
import { AlertService } from '@shared/toolkit/services/alert/alert.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

	public constructor(
		private authService: AuthService,
		private localStorageService: IpbLocalStorageService,
		public router: Router,
		private alertService: AlertService,
	) { }

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const tokenData = this.authService.getTokenData();
		const token = tokenData?.raw;
		const unit = tokenData?.unit ?? this.localStorageService.get('unit');

		if (!!tokenData?.isExpired || !tokenData && this.router.routerState.snapshot.url !== '/login') {
			this.authService.setReturnUrl(this.router.routerState.snapshot.url);
			this.router.navigate(['/login']);
		}

		let headers: HttpHeaders = request.headers;

		headers = headers.set('ipb-internaluser-unit', unit ?? '');
		if (!request.url.includes('login-api')) {
			// eslint-disable-next-line no-extra-boolean-cast
			if (!!token) headers = headers.set('Authorization', `Bearer ${token}`);
			headers = headers?.delete('no-wait');
		}

		// eslint-disable-next-line no-param-reassign
		request = request.clone({
			headers: headers,
		});
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				const ignoreUrls = ['/set-whatsapp-otp', '/support/resend-otp']

				const message =
					error.error?.errors?.[0] ?? 'An internal error has occurred, please try again.';

				if (error.url?.includes('/authorization/user/') && error.url?.includes('/roles'))
					this.router.navigate(['/login']);

				if (error.status != 401 && !ignoreUrls.some(part => error.url?.includes(part))) {
					const domain = error.status === 403 ? 'login' : 'general';
					this.alertService.error(message, `${domain}-error`);
				}
				return throwError(() => error);
			}),
			map((response) => {
				return response;
			}),
		);
	}
}
